export enum ConversationType {
  CHOP_GPT = "CHOP_GPT",
  POLICY_ASSISTANT = "POLICY_GPT",
  DOCUMENT_URL = "DOCUMENT_URL",
}

export const ConversationTypeDescription: Record<ConversationType, string> = {
  [ConversationType.CHOP_GPT]:
    "A general-purpose AI assistant for drafting, summarizing, analyzing documents, and more.",
  [ConversationType.POLICY_ASSISTANT]:
    "An AI assistant grounded in CHOP's official policies and procedures.",
  [ConversationType.DOCUMENT_URL]:
    "Analyze and ask questions about content from a specific document URL.",
};

export enum ChatTypes {
  CHOP = "chop-gpt",
  POLICY = "policy-gpt",
}

export enum MessageFeedbackType {
  POSITIVE = "positive",
  NEGATIVE = "negative",
}

export const MESSAGE_FEEDBACK = {
  positive: {
    header:
      "We’re glad you found the response useful! What specifically did you like about it?",
    placeholder:
      "Share what impressed you — relevance, completeness, or helpful details…(Optional)",
    tags: [],
  },
  negative: {
    header:
      "We appreciate your honesty! What could have made this response more useful?",
    placeholder: "Please provide additional details (Optional)",
    tags: [
      "Bug / Glitch",
      "Comprehensiveness",
      "Safety & Ethics",
      "Content Quality",
      "Tone & Engagement",
      "Consistency",
    ],
  },
};

export const MESSAGE_FEEDBACK_POLICY = {
  positive: {
    header:
      "We’re glad you found the response useful! What specifically did you like about it?",
    placeholder:
      "Share what impressed you — relevance, completeness, or helpful details…(Optional)",
    tags: [],
  },
  negative: {
    header:
      "We appreciate your honesty! What could have made this response more useful?",
    placeholder: "Please provide additional details",
    tags: [
      "Answer is correct but missing key information",
      "Answer is partially incorrect",
      "Answer is completely incorrect",
      "Answer could lead to a safety risk",
      "Relevant documents not retrieved"
    ],
  },
};

export const CHAT_CONFIG = {
  TEXTAREA: {
    MIN_HEIGHT: 32,
    MAX_HEIGHT: 180,
    PLACEHOLDER: "How can I help you today?",
  },
  TEMPERATURE: {
    MIN: 0,
    MAX: 1,
    STEP: 0.1,
    DEFAULT: 1,
    NOT_SUPPORTED_MODELS: ["gpt-5.6-terra", "gpt-5.2", "gpt-5", "gpt-5-mini", "o3", "o1", "gpt-5-pro"],
  },
  REASONING_EFFORT: {
    MIN: 0,
    MAX: 6,
    STEP: 2,
    DEFAULT: 0,
    MEDIUM: 4,
    NO_SUPPORTED_MODELS: ['DeepSeek-R1', 'gpt-5-pro'],
    LOW_LIMIT_REASONING_MODELS: ['o1', 'o3'],
  },
  MODELS: {
    DEFAULT: ["gpt-5.6-terra", "gpt-5.2", "gpt-5-mini", "gpt-5"],
    VISION_NOT_SUPPORTED: ['DeepSeek-R1']
  },
};

export const CHAT_SUGGESTIONS = {
  GPT: [
    {
      prompt: "Draft an email, letter, or a communication",
    },
    {
      prompt: "Upload a Word or PDF document and summarize its key points",
    },
    {
      prompt: "Analyze data to identify key insights and trends",
    },
    {
      prompt: "Translate text from one language into another",
    },
    {
      prompt: `Modify the tone, style, or reading level of an existing document`,
    },
  ],

  MOBILE_GPT: [
    {
      prompt: "Draft an email, letter, or a communication",
    },
    {
      prompt: "Upload a Word or PDF document and summarize its key points",
    },
    {
      prompt: "Analyze data to identify key insights and trends",
    },
    {
      prompt: "Translate text from one language into another",
    },
    {
      prompt:
        "Modify the tone, style, or reading level of an existing document ",
    },
  ],

  POLICY_ASSISTANT: [
    {
      prompt:
        "What are the standards for the insertion of a Central Venous Catheter (CVC)?",
    },
    {
      prompt: "What are the types of PPL provided by CHOP?",
    },
    {
      prompt: "What are the precautions for measles?",
    },
    {
      prompt: "What are the steps for administering intramuscular injections",
    },
  ],
};


export const BASE_VIEW_URL = `https://view.officeapps.live.com/op/embed.aspx`;

export const FILE_UPLOAD_CONFIG = {
  MAX_TOTAL_SIZE: 50 * 1024 * 1024,
  MAX_FILE_COUNT: 20,
  ALLOWED_EXTENSIONS: [
    ".txt",
    ".doc",
    ".docx",
    ".pdf",
    ".rtf",
    ".xlsx",
    ".xls",
    ".csv",
    ".pptx",
    ".ppt",
    ".jpeg",
    ".jpg",
    ".png",
    ".svg",
    ".html",
    ".aspx",
    ".php",
    ".py",
    ".java",
    ".js",
    ".json",
    ".rb",
    ".sh",
    ".ts",
    ".gitignore",
    ".xml",
    ".yml",
    ".yaml",
    ".jl",
    ".md",
    ".log",
    ".vtt",
    ".jmx",
    ".c",
    ".cpp",
    ".cs",
    ".sql",
    ".m",
    ".sas",
    ".r",
  ],
  BLOCKED_EXTENSIONS: [
    ".mp4",
    ".avi",
    ".mov",
    ".wmv",
    ".flv",
    ".mkv",
    ".webm",
    ".mp3",
    ".wav",
    ".aac",
    ".flac",
    ".ogg",
    ".m4a",
    ".wma",
  ],
};

export const FEEDBACK_SIDEBAR_WIDTH = {
  base: "w-full",
  md: "md:w-[320px]", // Tablet
  lg: "lg:w-[360px]", // Laptop
  xl: "xl:w-[380px]", // Desktop
};

export const FEEDBACK_SIDEBAR_WIDTH_CALC = {
  md: "md:w-[calc(100%-320px)]",
  lg: "lg:w-[calc(100%-360px)]",
  xl: "xl:w-[calc(100%-380px)]",
};
